import { waitTillTrue } from "@ms/gatsby-theme";

import { RootLayout } from "./src/layouts";

export const wrapRootElement = ({ element }) => <RootLayout>{element}</RootLayout>;

export const onRouteUpdate = () => {
  waitTillTrue(
    () => typeof window.rudderanalytics === "object",
    () =>
      window.rudderanalytics.page(
        { gatsbyBranch: process.env.BRANCH },
        {
          integrations: {
            All: false,
            GA4: true,
            Snowflake: true,
          },
        },
      ),
  );
};
